//Modules
import { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Icon } from '@iconify/react'

//Components
import { MdFacebook } from "react-icons/md";
import { SiLinkedin } from "react-icons/si";
import { BsYoutube } from "react-icons/bs";

//Utilities
import { menuContext } from '../utils/UtilContext'
import useFetch from '../utils/useFetch'

//Assets
import logo from '../../img/logo_ESE_cor_2026.svg'
import ipbnews from '../../img/logoIPBNews.png'
import starsEU from '../../img/starseu_icon.svg'

//Variables
const { REACT_APP_WP_MENU_PROTPROJ, REACT_APP_CACHE_EP_MENU } = process.env

const Footer = () => {
    const { navItemsTotal, CACHE_API_URL } = useContext(menuContext)
    const { data: protocolosProjetos } = useFetch(`${CACHE_API_URL}${REACT_APP_CACHE_EP_MENU}${REACT_APP_WP_MENU_PROTPROJ}`)

    let history = useLocation()
    const lang = history.pathname.substring(1,3)

    return (
            <footer>
                <div className="separator"></div>    
                <section className="infoFooter">
                    <div className='container'>
                        {navItemsTotal.menuFooter && navItemsTotal.menuFooter.items.map((item) =>(                        
                            <ul key={item.ID} className="">
                                {item?.child_items && item.child_items.map((child) => (                                                                
                                    <li key={child.ID}>
                                        <div id={`${child.slug}_${child.ID}`} className='renderedTitle' dangerouslySetInnerHTML={{__html:child['title_'+lang]}}></div>
                                        <ul className="">
                                            {child?.child_items && child.child_items.map((subChild) => (
                                                <li key={subChild.ID} className="">
                                                    {subChild.object === "custom" ?
                                                            <a href={subChild.url} target="_blank" rel="noreferrer" id={`${subChild.slug}_${subChild.ID}`}>
                                                                <div className='renderedTitle' dangerouslySetInnerHTML={{__html:subChild['title_'+lang]}}></div>
                                                            </a>
                                                        :
                                                            <Link to={`/${lang}/${item['slug_'+lang]}/${child['slug_'+lang]}/${subChild['slug_'+lang]}`} id={`${subChild.slug}_${subChild.ID}`}>
                                                                <div className='renderedTitle' dangerouslySetInnerHTML={{__html:subChild['title_'+lang]}}></div>
                                                            </Link>}
                                                </li>
                                            ))}                                                                                        
                                        </ul>
                                    </li>
                                ))}
                                <li className='ipb-news'>
                                    <img src={ipbnews} alt="Logotipo IPB News" />
                                    <a href='https://ipbnews.ipb.pt' target='_blank' rel="noreferrer">Partilha de Notícias e Eventos</a>
                                </li>
                            </ul>                   
                        ))} 
                    </div>
                </section>
                <section className='ContactsFooter'>
                    <div className="container">
                        <div className="footerLogo">
                            <img src={logo} alt="Logo IPB" className="footerLogoIPB" />
                            <Link to={`/${lang}/internacionalizar/internacionalizar-mais/stars-eu`}>
                                <img src={starsEU} height="75px" alt="Logotipo StarsEU" />
                            </Link>
                        </div>   
                        <div className='contacts'>
                            <p>Campus de Santa Apolónia 5300-253 Bragança, Portugal
                            <br />T: (351) 273 303 200 / 273 331 570</p>
                        </div> 
                        <div className='redesSociais'>                                      
                            <ul>
                                <li><a href="https://facebook.com/ipbraganca" target="_blank" rel="noreferrer"><MdFacebook /></a></li>
                                <li><a href="https://www.instagram.com/institutopolitecnicobraganca" target="_blank" rel="noreferrer"><SiLinkedin /></a></li>
                                <li><a href="https://www.youtube.com/c/InstitutoPolit%C3%A9cnicodeBragan%C3%A7a" target="_blank" rel="noreferrer"><BsYoutube /></a></li>
                            </ul>
                        </div>                                          
                    </div>
                </section>
                <section className="protocolosProjetos">
                    <div className="container">
                        <p>Projetos financiados:</p>
                        <ul>
                            {protocolosProjetos ?
                                protocolosProjetos.items.map((protProj) => (
                                    protProj.url.includes("http") ?
                                        <li key={protProj.ID}><a href={protProj.url} target="_blank" rel='noreferrer'><img src={protProj?.acf.imagem} title={protProj.post_title} alt={protProj.post_title} /></a></li>
                                        :<li key={protProj.ID}><Link to={`/${lang}${protProj.url}`} ><img src={protProj?.acf.imagem} title={protProj.post_title} alt={protProj.post_title} /></Link></li>     
                                ))
                                
                                : <Icon icon="svg-spinners:eclipse" />
                            }                            
                        </ul>
                    </div>
                </section>
            </footer>
            )
}

export default Footer
